interface IPaper {
  id?: number,
  author: string,
  title: string,
  publisher: string,
  version: string | null,
  year: number,
  doi: string | null,
  page: string | null,
  filename: string,
  imgSrc?: string,
  download: boolean,
}

/**
 * 1. Id is useless, only tells you that it is sorted in ascending order.
 * 2. The data originally resides in the database, so id is required as the primary key.
 * 3. If you do not plan to use the database in the future, you can no longer write id.
 * P.S.:
 * The reason for not using Chinese annotations is that the file encoding may cause garbled characters.
 */
export const paper2016: IPaper[] = [
  {
    "id": 1,
    "author": "Guojiang Shen, Wenfeng Chen",
    "title": "Regional coordinated control method based on decision-selection and its application",
    "publisher": "Journal of Zhejiang University of Technology",
    "version": "3",
    "year": 2016,
    "doi": null,
    "page": "1",
    "filename": "Regional coordinated control method based on decision-selection and its application.pdf",
    "download": true
  },
  {
    "id": 2,
    "author": "Ahmedin Mohammed Ahmed, Xiangjie Kong, Li Liu, Feng Xia, Saeid Abolfazli, Zohreh Sanaei, Amr Tolba",
    "title": "BoDMaS: Bio-inspired Selfishness Detection and Mitigation in Data Management for Ad-hoc Social Networks",
    "publisher": "Ad Hoc Networks",
    "version": "55",
    "year": 2016,
    "doi": "10.1016/j.adhoc.2016.09.013",
    "page": "119-131",
    "filename": "BoDMaS bio-inspired selfishness detection and mitigation in data management for adhoc social networks.pdf",
    "download": true
  }
]

export const paper2017: IPaper[] = [
  {
    "id": 3,
    "author": "Guojiang Shen, Huang Wei, Xi Yang",
    "title": "Communication-reducing diffusion LMS algorithm over multitask networks",
    "publisher": "Information Sciences",
    "version": "382",
    "year": 2017,
    "doi": "10.1016/j.ins.2016.12.010",
    "page": "115-134",
    "filename": "Communication-reducing.pdf",
    "download": true
  },
  {
    "id": 4,
    "author": "Jianwei Zheng, Ping Yang, Shengyong Chen, Guojiang Shen, Wanliang Wang",
    "title": "Iterative Re-Constrained Group Sparse Face Recognition With Adaptive Weights Learning",
    "publisher": "IEEE transactions on image processing(TIP)",
    "version": "26.5",
    "year": 2017,
    "doi": "10.1109/TIP.2017.2681841",
    "page": "2408-2423",
    "filename": "Iterative reconstrained group sparse face recognition with adaptive weights learning.pdf",
    "download": true
  },
  {
    "id": 5,
    "author": "Guojiang Shen, Yang Xi, Fuhua Wan, Mengchuan Tu",
    "title": "Robust output synchronization of heterogeneous nonlinear agents in uncertain networks",
    "publisher": "ISA transactions",
    "version": "71",
    "year": 2017,
    "doi": "10.1016/j.isatra.2017.07.014",
    "page": "170-177",
    "filename": "Robust output synchronization of heterogeneous nonlinear agents in uncertain networks .pdf",
    "download": true
  },
  {
    "id": 6,
    "author": "Xiangjie Kong, Feng Xia, Jinzhong Wang, Azizur Rahim, Sajal K",
    "title": "Time-location-relationship combined service recommendation based on taxi trajectory data",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE Trans Industr Inform)",
    "version": "13.3",
    "year": 2017,
    "doi": "10.1109/TII.2017.2684163",
    "page": "1202-1212",
    "filename": "Time-Location-Relationship Combined Service.pdf",
    "download": true
  },
  {
    "id": 7,
    "author": "Zhaolong Ning, Feng Xia, Noor Ullah, Xiangjie Kong, Xiping Hu",
    "title": "Vehicular Social Networks: Enabling Smart Mobility",
    "publisher": "IEEE Communications Magazine",
    "version": "55.5",
    "year": 2017,
    "doi": "10.1109/MCOM.2017.1600263",
    "page": "16-55",
    "filename": "Vehicular social networks Enabling smart mobility.pdf",
    "download": true
  },
  {
    "id": 8,
    "author": "Zhaolong Ning, Xiaojie Wang, Xiangjie Kong, and Weigang Hou",
    "title": "A social-aware group formation framework for information diffusion in narrowband internet of things",
    "publisher": "IEEE Internet of Things Journal",
    "version": null,
    "year": 2017,
    "doi": "10.1109/JIOT.2017.2777480",
    "page": null,
    "filename": "A social-aware group formation framework for information diffusion in narrowband internet of things.pdf",
    "download": true
  },
  {
    "id": 9,
    "author": "Feng Xia, Azizur Rahim, Xiangjie Kong, Meng Wang, Yinqiong Cai, and Jinzhong Wang",
    "title": "Modeling and Analysis of Large-Scale Urban Mobility for Green Transportation",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE Trans Industr Inform)",
    "version": null,
    "year": 2017,
    "doi": "10.1109/TII.2017.2785383",
    "page": null,
    "filename": "Modeling and Analysis of Large-Scale Urban Mobility for Green Transportation.pdf",
    "download": true
  },
  {
    "id": 10,
    "author": "Liangtian Wan, Xiangjie Kong, Feng Xia",
    "title": "Joint Range-Doppler-Angle Estimation for Intelligent Tracking of Moving Aerial Targets",
    "publisher": "IEEE Internet of Things Journal",
    "version": null,
    "year": 2017,
    "doi": "10.1109/JIOT.2017.2787785",
    "page": null,
    "filename": "Joint Range-Doppler-Angle Estimation for Intelligent Tracking of Moving Aerial Targets.pdf",
    "download": true
  }
]

export const paper2018: IPaper[] = [
  {
    "id": 11,
    "author": "Xiangjie Kong, Feng Xia, Zhaolong Ning, Azizur Rahim, Yinqiong Cai, Zhiqiang Gao, Jianhua Ma",
    "title": "Mobility Dataset Generation for Vehicular Social Networks Based on Floating Car Data",
    "publisher": "IEEE Transactions on Vehicular Technology(IEEE Trans. Veh. Technol)",
    "version": "67.5",
    "year": 2018,
    "doi": "10.1109/TVT.2017.2788441",
    "page": "3874-3886",
    "filename": "Mobility Dataset Generation for Vehicular Social Networks Based on Floating Car Data.pdf",
    "download": true
  },
  {
    "id": 12,
    "author": "Xiangjie Kong, Kai Ma, Shen Hou, Di Shang, and Feng Xia",
    "title": "Human Interactive Behaviour: A Bibliographic Review",
    "publisher": "IEEE Access",
    "version": "7",
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2887341",
    "page": "4611-4628",
    "filename": "Human Interactive Behaviour A Bibliographic Review.pdf",
    "download": true
  },
  {
    "id": 13,
    "author": "Jialong Zhang, Jianguo Yan, Maolong Lv, Xiangjie Kong, and Pu Zhang",
    "title": "UAV Formation Flight Cooperative Tracking Controller Design",
    "publisher": "International Conference on Control, Automation, Robotics and Vision (ICARCV)",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ICARCV.2018.8581093",
    "page": null,
    "filename": "UAV Formation Flight Cooperative Tracking Controller Design.pdf",
    "download": true
  },
  {
    "id": 14,
    "author": "Xiangjie Kong, Mengyi Mao, Jiaying Liu, Bo Xu, Ruihe Huang, and Qun Jin",
    "title": "TNERec: Topic-Aware Network Embedding for Scientific Collaborator Recommendation",
    "publisher": "2018 IEEE SmartWorld, Ubiquitous Intelligence & Computing, Advanced & Trusted Computing, Scalable Computing & Communications, Cloud & Big Data Computing, Internet of People and Smart City Innovation (SmartWorld/SCALCOM/UIC/ATC/CBDCom/IOP/SCI)",
    "version": null,
    "year": 2018,
    "doi": "10.1109/SmartWorld.2018.00177",
    "page": null,
    "filename": "TNERec Topic-Aware Network Embedding for Scientific Collaborator Recommendation.pdf",
    "download": true
  },
  {
    "id": 15,
    "author": "Zhaolong Ning, Peiran Dong, Xiangjie Kong, and Feng Xia",
    "title": "A cooperative partial computation offloading scheme for mobile edge computing enabled Internet of Things",
    "publisher": "IEEE Internet of Things Journal",
    "version": null,
    "year": 2018,
    "doi": "10.1109/JIOT.2018.2868616",
    "page": null,
    "filename": "A Cooperative Partial Computation Offloading Scheme for Mobile Edge Computing Enabled Internet of Things.pdf",
    "download": true
  },
  {
    "id": 16,
    "author": "Xiangjie Kong, Menglin Li, Tao Tang, Kaiqi Tian, Luis Moreira-Matias, Feng Xia",
    "title": "Shared Subway Shuttle Bus Route Planning Based on Transport Data Analytics",
    "publisher": "IEEE Transactions on Automation Science and Engineering(IEEE T AUTOM SCI ENG)",
    "version": "15.4",
    "year": 2018,
    "doi": "10.1109/TASE.2018.2865494",
    "page": "1507-1520",
    "filename": "Shared Subway Shuttle Bus Route Planning Based on Transport Data Analytics.pdf",
    "download": true
  },
  {
    "id": 17,
    "author": "Jialong Zhang, Jianguo Yan, Pu Zhang, and Xiangjie Kong",
    "title": "Design and Information Architectures for an Unmanned Aerial Vehicle Cooperative Formation Tracking Controller",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2865807",
    "page": null,
    "filename": "Design and Information Architectures for an Unmanned Aerial Vehicle Cooperative Formation Tracking Controller.pdf",
    "download": true
  },
  {
    "id": 18,
    "author": "Rui Chen, Qingyi Hua, Yan-Shuo Chang, Bo Wang, Lei Zhang, and Xiangjie Kong",
    "title": "A Survey of Collaborative Filtering-Based Recommender Systems: from Traditional Methods to Hybrid Methods Based on Social Networks",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2877208",
    "page": null,
    "filename": "A Survey of Collaborative Filtering-Based Recommender Systems from Traditional Methods to Hybrid Methods Based on Social Networks.pdf",
    "download": true
  },
  {
    "id": 19,
    "author": "Tao Tang, Xiangjie Kong, Menglin Li, Jinzhong Wang, Guojiang Shen, and Xinshuang Wang",
    "title": "VISOS: A Visual Interactive System for Spatial-temporal Exploring Station Importance Based on Subway Data",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2858260",
    "page": null,
    "filename": "VISOS A Visual Interactive System for Spatial-temporal Exploring Station Importance Based on Subway Data.pdf",
    "download": true
  },
  {
    "id": 20,
    "author": "Laisen Nie, Yongkang Li, and Xiangjie Kong",
    "title": "Spatio-Temporal Network Traffic Estimation and Anomaly Detection Based on Convolutional Neural Network in Vehicular Ad-Hoc Networks",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2854842",
    "page": null,
    "filename": "Spatio-Temporal Network Traffic Estimation and Anomaly Detection Based on Convolutional Neural Network in Vehicular Ad-Hoc Networks.pdf",
    "download": true
  },
  {
    "id": 21,
    "author": "Tianhan Gao, Xinyang Deng, Yingbo Wang, and Xiangjie Kong",
    "title": "PAAS: PMIPv6 Access Authentication Scheme based on Identity-based Signature in VANETs",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2841008",
    "page": null,
    "filename": "PAAS PMIPv6 Access Authentication Scheme based on Identity-based Signature in VANETs.pdf",
    "download": true
  },
  {
    "id": 22,
    "author": "Jiaying Liu, Xiangjie Kong, Feng Xia, Xiaomei Bai, Lei Wang, Qing Qing, and Ivan Lee",
    "title": "Artificial Intelligence in the 21st Century",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2819688",
    "page": null,
    "filename": "Artificial Intelligence in the 21st Century.pdf",
    "download": true
  },
  {
    "id": 23,
    "author": "Jiaying Liu, Tao Tang, Wei Wang, Bo Xu, Xiangjie Kong, and Feng Xia",
    "title": "A survey of scholarly data visualization",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2815030",
    "page": null,
    "filename": "A Survey of Scholarly Data Visualization.pdf",
    "download": true
  },
  {
    "id": 24,
    "author": "Jinzhong Wang, Xiangjie Kong, Wenhong Zhao, Amr Tolba, Zafer Al-Makhadmeh, and Feng Xia",
    "title": "STLoyal: A Spatio-Temporal Loyalty-Based Model for Subway Passenger Flow Prediction",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2865921",
    "page": null,
    "filename": "STLoyal A Spatio-Temporal Loyalty-Based Model for Subway Passenger Flow Prediction.pdf",
    "download": true
  },
  {
    "id": 25,
    "author": "Jialong Zhang, Jianguo Yan, Pu Zhang, and Xiangjie Kong",
    "title": "Collision Avoidance in Fixed-Wing UAV Formation Flight Based on a Consensus Control Algorithm",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2864169",
    "page": null,
    "filename": "Collision Avoidance in Fixed-Wing UAV Formation Flight Based on a Consensus Control Algorithm.pdf",
    "download": true
  },
  {
    "id": 26,
    "author": "Bo Xu, Lu Li, Jiaying Liu, Liangtian Wan, Xiangjie Kong, and Feng Xia",
    "title": "Disappearing Link Prediction in Scientific Collaboration Networks",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2880233",
    "page": null,
    "filename": "Disappearing Link Prediction in Scientific Collaboration Networks..pdf",
    "download": true
  },
  {
    "id": 27,
    "author": "Xiangjie Kong, Mengyi Mao, Wei Wang, Jiaying Liu, Bo Xu",
    "title": "VOPRec: Vector Representation Learning of Papers with Text Information and Structural Identity for Recommendation",
    "publisher": "IEEE Transactions on Emerging Topics in Computing(IEEE Trans. Emerging Top)",
    "version": null,
    "year": 2018,
    "doi": "10.1109/TETC.2018.2830698",
    "page": null,
    "filename": "VOPRec Vector Representation Learning of Papers with Text Information and Structural Identity for Recommendation.pdf",
    "download": true
  },
  {
    "id": 28,
    "author": "Feng Xia, Jinzhong Wang, Xiangjie Kong, Zhibo Wang, Jianxin Li, and Chengfei Liu",
    "title": "Exploring Human Mobility Patterns in Urban Scenarios: A Trajectory Data Perspective",
    "publisher": "IEEE Communications Magazine",
    "version": null,
    "year": 2018,
    "doi": "10.1109/MCOM.2018.1700242",
    "page": null,
    "filename": "Exploring Human Mobility Patterns in Urban Scenarios A Trajectory Data Perspective.pdf",
    "download": true
  },
  {
    "id": 29,
    "author": "Xiangjie Kong, Menglin Li, Kai Ma, Kaiqi Tian, Mengyuan Wang, Zhaolong Ning, Feng Xia",
    "title": "Big Trajectory Data: A Survey of Applications and Services",
    "publisher": "IEEE Access",
    "version": "6",
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2873779",
    "page": "58295-58306",
    "filename": "Big Trajectory Data A Survey of Applications and Services.pdf",
    "download": true
  },
  {
    "id": 30,
    "author": "Xiangjie Kong, Ximeng Song, Feng Xia, Haochen Guo, Jinzhong Wang, and Amr Tolba",
    "title": "LoTAD: long-term traffic anomaly detection based on crowdsourced bus trajectory data",
    "publisher": "World Wide Web(WWW)",
    "version": null,
    "year": 2018,
    "doi": "10.1007/s11280-017-0487-4",
    "page": null,
    "filename": "LoTAD long-term traffic anomaly detection based on crowdsourced bus trajectory data.pdf",
    "download": true
  },
  {
    "id": 31,
    "author": "Noor Ullah, Xiangjie Kong, Liangtian Wan, Honglong Chen, Zhibo Wang, and Feng Xia",
    "title": "A Social Utility-Based Dissemination Scheme for Emergency Warning Messages in Vehicular Social Networks",
    "publisher": "The Computer Journal",
    "version": null,
    "year": 2018,
    "doi": "10.1093/comjnl/bxy026",
    "page": null,
    "filename": "A Social Utility-Based Dissemination Scheme for Emergency Warning Messages in Vehicular Social Networks.pdf",
    "download": true
  },
  {
    "id": 32,
    "author": "Jiaying Liu, Tao Tang, Xiangjie Kong, Amr Tolba, AL-Makhadmeh Zafer, and Feng Xia",
    "title": "Understanding the advisor–advisee relationship via scholarly data analysis",
    "publisher": "Scientometrics",
    "version": null,
    "year": 2018,
    "doi": "10.1007/s11192-018-2762-2",
    "page": null,
    "filename": "Understanding the advisor–advisee relationship via scholarly data analysis.pdf",
    "download": true
  },
  {
    "id": 33,
    "author": "Tao Tang, Xin Dong, Jinzhong Wang, Xiangjie Kong, Azizur Rahim, Xuannian Yu, and Yulin Li",
    "title": "FISS: Function identification of subway stations based on semantics mining and functional clustering",
    "publisher": "IET Intelligent Transport Systems",
    "version": null,
    "year": 2018,
    "doi": "10.1049/iet-its.2017.0316",
    "page": null,
    "filename": "FISS Function identification of subway stations based on semantics mining and functional clustering.pdf",
    "download": true
  },
  {
    "id": 34,
    "author": "Xiaomei Bai, Fuli Zhang, Jie Hou, Ivan Lee, Xiangjie Kong, Amr Tolba, and Feng Xia",
    "title": "Quantifying the impact of scholarly papers based on higher-order weighted citations",
    "publisher": "PloS one",
    "version": null,
    "year": 2018,
    "doi": "10.1371/journal.pone.0193192",
    "page": null,
    "filename": "Quantifying the impact of scholarly papers based on higher-order weighted citations.pdf",
    "download": true
  },
  {
    "id": 35,
    "author": "Azizur Rahim, Xiangjie Kong, Feng Xia, Zhaolong Ning, Noor Ullah, Jinzhong Wang, and Sajal K. Das",
    "title": "Vehicular Social Networks: A survey",
    "publisher": "Pervasive and Mobile Computing(Pervasive Mob Comput)",
    "version": null,
    "year": 2018,
    "doi": "10.1016/j.pmcj.2017.12.004",
    "page": null,
    "filename": "Vehicular Social Networks A survey.pdf",
    "download": true
  },
  {
    "id": 36,
    "author": "Guojiang Shen, Xiao Han, Junjie Zhou, Zhongyuan Ruan, Qihong Pan",
    "title": "Research on intelligent analysis and depth fusion of multi-source traffic data",
    "publisher": "IEEE Access",
    "version": null,
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2872805",
    "page": null,
    "filename": "Research on Intelligent Analysis and depth Fusion of Multi-source Traffic data.pdf",
    "download": true
  },
  {
    "id": 37,
    "author": "Jianwei Zhen, Chen Lu, Mengjie Qin, Wanjun Chen",
    "title": "联合特征选择和光滑表示的子空间聚类算法",
    "publisher": "模式识别与人工智能",
    "version": "05",
    "year": 2018,
    "doi": null,
    "page": "409-418",
    "filename": "联合特征选择和光滑表示的子空间聚类算法_郑建炜.pdf",
    "download": true
  },
  {
    "id": 38,
    "author": "Zhi Liu, Xiaoshan Pan",
    "title": "基于渲染图像角度结构特征的三维模型检索方法",
    "publisher": "计算机科学",
    "version": "45.11A",
    "year": 2018,
    "doi": null,
    "page": "251-255",
    "filename": "基于渲染图像角度结构特征的三维模型检索方法_刘志.pdf",
    "download": true
  },
  {
    "id": 51,
    "author": "Xiangjie Kong, Kai Ma, Shen Hou, Di Shang, and Feng Xia",
    "title": "Human Interactive Behavior: A Bibliographic Review",
    "publisher": "IEEE Access",
    "version": "7",
    "year": 2018,
    "doi": "10.1109/ACCESS.2018.2887341",
    "page": "4611-4628",
    "filename": "Human Interactive Behavior A Bibliographic Review.pdf",
    "download": true
  },
  {
    "id": 55,
    "author": "Zhaolong Ning, Xiangjie Kong, Feng Xia, Weigang Hou, and Xiaojie Wang",
    "title": "Green and Sustainable Cloud of Things: Enabling Collaborative Edge Computing",
    "publisher": "IEEE Communications Magazine",
    "version": "57.1",
    "year": 2018,
    "doi": "10.1109/MCOM.2018.1700895",
    "page": "72-78",
    "filename": "Green and Sustainable Cloud of Things Enabling Collaborative Edge Computing.pdf",
    "download": true
  }
]

export const paper2019: IPaper[] = [
  {
    "id": 39,
    "author": "Xiangjie Kong, Menglin Li, Jianxin Li, Kaiqi Tian, Xiping Hu, and Feng Xia",
    "title": "CoPFun: an urban co-occurrence pattern mining scheme based on regional function discovery",
    "publisher": "World Wide Web(WWW)",
    "version": "22.3",
    "year": 2019,
    "doi": "10.1007/s11280-018-0578-x",
    "page": "1029-1054",
    "filename": "CoPFun An Urban Co-occurrence Pattern Mining Scheme Based on Regional Function Discovery.pdf",
    "download": true
  },
  {
    "id": 40,
    "author": "Weijing Qi, Qingyang Song, Xiangjie Kong, and Lei Guo",
    "title": "A traffic-differentiated routing algorithm in Flying Ad Hoc Sensor Networks with SDN cluster controllers",
    "publisher": "Journal of the Franklin Institute(J Franklin Inst)",
    "version": "356.2",
    "year": 2019,
    "doi": "10.1016/j.jfranklin.2017.11.012",
    "page": "766-790",
    "filename": "A Traffic-Differentiated Routing Algorithm in Flying Ad Hoc Sensor Networks with SDN Cluster Controllers.pdf",
    "download": true
  },
  {
    "id": 41,
    "author": "Xiangjie Kong，Yajie Shi, Wei Wang, Kai Ma, Liangtian Wan, Feng Xia",
    "title": "The Evolution of Turing Award Collaboration Network: Bibliometric-level and Network-level Metrics",
    "publisher": "IEEE Transactions on Computational Social Systems(IEEE Trans. Comput. Social Syst)",
    "version": "6.6",
    "year": 2019,
    "doi": "10.1109/TCSS.2019.2950445",
    "page": "1318-1328",
    "filename": "The Evolution of Turing Award Collaboration Network Bibliometric-level and Network-level Metrics.pdf",
    "download": true
  },
  {
    "id": 42,
    "author": "Jiaying Liu, Feng Xia, Lei Wang, Bo Xu, Xiangjie Kong, Hanghang Tong, Irwin King",
    "title": "Shifu2: A Network Representation Learning Based Model for Advisor-advisee Relationship Mining",
    "publisher": "IEEE Transactions on Knowledge and Data Engineering(IEEE Trans. Knowl)",
    "version": null,
    "year": 2019,
    "doi": "10.1109/TKDE.2019.2946825",
    "page": null,
    "filename": "Shifu2 A Network Representation Learning Based Model for Advisor-advisee Relationship Mining.pdf",
    "download": true
  },
  {
    "id": 43,
    "author": "Feng Xia, Jiaying Liu, Hansong Nie, Yonghao Fu, Liangtian Wan, Xiangjie Kong",
    "title": "Random Walks: A Review of Algorithms and Applications",
    "publisher": "IEEE Transactions on Emerging Topics in Computational Intelligence()",
    "version": "4.2",
    "year": 2019,
    "doi": "10.1109/TETCI.2019.2952908",
    "page": null,
    "filename": "Random Walks A Review of Algorithms and Applications.pdf",
    "download": true
  },
  {
    "id": 44,
    "author": "Liangtian Wan, Lu Sun, Xiangjie Kong, Yuyuan Yuan, Ke Sun, and Feng Xia",
    "title": "Task-Driven Resource Assignment in Mobile-Edge Computing Exploiting Evolutionary Computation",
    "publisher": "IEEE Wireless Communications(IEEE Wireless Commun)",
    "version": "26.6",
    "year": 2019,
    "doi": "10.1109/MWC.001.1800582",
    "page": null,
    "filename": "Task-Driven Resource Assignment in Mobile-Edge Computing Exploiting Evolutionary Computation.pdf",
    "download": true
  },
  {
    "id": 45,
    "author": "Zhaolong Ning, Peiran Dong, Xiaojie Wang, Lei Guo, Joel J. P. C. Rodrigues, Xiangjie Kong, Jun Huang, Ricky Y. K. Kwok",
    "title": "Deep Reinforcement Learning for Intelligent Internet of Vehicles: An Energy-Efficient Computational Offloading Scheme",
    "publisher": "IEEE Transactions on Cognitive Communications and Networking(IEEE Trans. Cognit. Commun. Networking)",
    "version": "5.4",
    "year": 2019,
    "doi": "10.1109/TCCN.2019.2930521",
    "page": null,
    "filename": "Deep Reinforcement Learning for Intelligent Internet of Vehicles An Energy-Efficient Computational Offloading Scheme.pdf",
    "download": true
  },
  {
    "id": 46,
    "author": "Zhaolong Ning, Yufan Feng, Mario Collotta, Xiangjie Kong, Xiaojie Wang, Lei Guo, Xiping Hu, Bin Hu",
    "title": "Deep Learning in Edge of Vehicles: Exploring Tri-Relationship for Data Transmission",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE Trans Industr Inform)",
    "version": "15.10",
    "year": 2019,
    "doi": "10.1109/TII.2019.2929740",
    "page": null,
    "filename": "Deep learning in edge of vehicles Exploring trirelationship for data transmission.pdf",
    "download": true
  },
  {
    "id": 47,
    "author": "Xiangjie Kong, Xiaoteng Liu, Behrouz Jedari, Menglin Li, Liangtian Wan, Feng Xia",
    "title": "Mobile Crowdsourcing in Smart Cities: Technologies, Applications and Future Challenges",
    "publisher": "IEEE Internet of Things Journal(IEEE Internet Things J)",
    "version": "6.5",
    "year": 2019,
    "doi": "10.1109/JIOT.2019.2921879",
    "page": null,
    "filename": "Mobile Crowdsourcing in Smart Cities Technologies, Applications and Future Challenges.pdf",
    "download": true
  },
  {
    "id": 48,
    "author": "Feng Xia, Jinzhong Wang, Xiangjie Kong, Da Zhang, Zhibo Wang",
    "title": "Ranking Station Importance with Human Mobility Patterns Using Subway Network Datasets",
    "publisher": "IEEE Transactions on Intelligent Transportation Systems(IEEE Trans. Intell. Transp. Syst)",
    "version": null,
    "year": 2019,
    "doi": "10.1109/TITS.2019.2920962",
    "page": null,
    "filename": "Ranking Station Importance With Human Mobility Patterns Using Subway Network Datasets.pdf",
    "download": true
  },
  {
    "id": 49,
    "author": "Xiangjie Kong, Feng Xia, Kai Ma, Jianxin Li, Qiuyuang Yang",
    "title": "Discovering Transit-Oriented Development Regions of Mega Cities Using Heterogeneous Urban Data",
    "publisher": "IEEE Transactions on Computational Social Systems(IEEE Trans. Comput. Social Syst)",
    "version": "6.5",
    "year": 2019,
    "doi": "10.1109/TCSS.2019.2919960",
    "page": null,
    "filename": "Discovering Transit-Oriented Development Regions of Mega Cities Using Heterogeneous Urban Data.pdf",
    "download": true
  },
  {
    "id": 50,
    "author": "Wei Wang, Jiaying Liu, Zhuo Yang, Xiangjie Kong, and Feng Xia",
    "title": "Sustainable Collaborator Recommendation Based on Conference Closure",
    "publisher": "IEEE Transactions on Computational Social Systems(IEEE Trans. Comput. Social Syst)",
    "version": "6.2",
    "year": 2019,
    "doi": "10.1109/TCSS.2019.2898198",
    "page": "311-322",
    "filename": "Sustainable Collaborator Recommendation Based on Conference Closure.pdf",
    "download": true
  },
  {
    "id": 52,
    "author": "Xiaomei Bai, Mengyang Wang, Ivan Lee, Zhuo Yang, Xiangjie Kong, and Feng Xia",
    "title": "Scientific Paper Recommendation: A Survey",
    "publisher": "IEEE Access",
    "version": "7",
    "year": 2019,
    "doi": "10.1109/ACCESS.2018.2890388",
    "page": "9324-9339",
    "filename": "Scientific Paper Recommendation A Survey.pdf",
    "download": true
  },
  {
    "id": 53,
    "author": "Rui Chen, Qingyi Hua, Bo Wang, Min Zheng, Weili Guan, Xiang Ji, Quanli Gao, and Xiangjie Kong",
    "title": "A Novel Social Recommendation Method Fusing User’s Social Status and Homophily Based on Matrix Factorization Techniques",
    "publisher": "IEEE Access",
    "version": "7",
    "year": 2019,
    "doi": "10.1109/ACCESS.2019.2893024",
    "page": "18783-18798",
    "filename": "A Novel Social Recommendation Method Fusing User’s Social Status and Homophily Based on Matrix Factorization Techniques.pdf",
    "download": true
  },
  {
    "id": 54,
    "author": "Xiangjie Kong, Menglin Li, Gaoxing Zhao, Huijie Zhang, Feng Xia",
    "title": "COOC: Visual Exploration of Co-occurrence Mobility Patterns in Urban Scenarios",
    "publisher": "IEEE Transactions on Computational Social Systems(IEEE Trans. Comput. Social Syst)",
    "version": "6.3",
    "year": 2019,
    "doi": "10.1109/TCSS.2018.2883582",
    "page": "403-413",
    "filename": "COOC Visual Exploration of Co-occurrence Mobility Patterns in Urban Scenarios.pdf",
    "download": true
  },
  {
    "id": 56,
    "author": "Jie Hou, Hanxiao Pan, Teng Guo, Ivan Lee, Xiangjie Kong, and Feng Xia",
    "title": "Prediction methods and applications in the science of science: A survey",
    "publisher": "Computer Science Review",
    "version": "34",
    "year": 2019,
    "doi": "10.1016/j.cosrev.2019.100197",
    "page": "100197",
    "filename": "Prediction methods and applications in the science of science A survey.pdf",
    "download": true
  },
  {
    "id": 57,
    "author": "Jiaying Liu, Xiangjie Kong, Xinyu Zhou, Lei Wang, Da Zhang, Ivan Lee, Bo Xu, and Feng Xia",
    "title": "Data Mining and Information Retrieval in the 21st century: A bibliographic review",
    "publisher": "Computer Science Review",
    "version": "34",
    "year": 2019,
    "doi": "10.1016/j.cosrev.2019.100193",
    "page": "100193",
    "filename": "Data Mining and Information Retrieval in the 21st century A bibliographic review.pdf",
    "download": true
  },
  {
    "id": 58,
    "author": "Xiangjie Kong, Mengyi Mao, Huizhen Jiang, Shuo Yu, and Liangtian Wan",
    "title": "How does collaboration affect researchers’ positions in co-authorship networks?",
    "publisher": "Journal of Informetrics",
    "version": "13.3",
    "year": 2019,
    "doi": "10.1016/j.joi.2019.07.005",
    "page": "887-900",
    "filename": "How does collaboration affect researchers’ positions in co-authorship networks.pdf",
    "download": true
  },
  {
    "id": 60,
    "author": "Wei Wang, Bo Xu, Jiaying Liu, Zixin Cui, Shuo Yu, Xiangjie Kong, and Feng Xia",
    "title": "CSTeller: forecasting scientific collaboration sustainability based on extreme gradient boosting",
    "publisher": "World Wide Web(WWW)",
    "version": "22.6",
    "year": 2019,
    "doi": "10.1007/s11280-019-00703-y",
    "page": "2749-2770",
    "filename": "CSTeller Forecasting scientific collaboration sustainability based on extreme gradient boosting.pdf",
    "download": true
  },
  {
    "id": 61,
    "author": "Jinzhong Wang, Xiangjie Kong, Feng Xia, and Lijun Sun",
    "title": "Urban Human Mobility: Data-Driven Modeling and Prediction",
    "publisher": "ACM SIGKDD Explorations Newsletter(ACM)",
    "version": "21.1",
    "year": 2019,
    "doi": "10.1145/3331651.3331653",
    "page": "1-19",
    "filename": "Urban Human Mobility Data-Driven Modeling and Prediction.pdf",
    "download": true
  },
  {
    "id": 62,
    "author": "Jiaying Liu, Jiahao Tian, Xiangjie Kong, Ivan Lee, and Feng Xia",
    "title": "Two decades of information systems: a bibliometric review",
    "publisher": "Scientometrics",
    "version": "118.2",
    "year": 2019,
    "doi": "10.1007/s11192-018-2974-5",
    "page": "617-643",
    "filename": "Two decades of information systems a bibliometric review.pdf",
    "download": true
  },
  {
    "id": 63,
    "author": "Xiangjie Kong, Lei Liu, Shuo Yu, Andong Yang, Xiaomei Bai, Bo Xu",
    "title": "Skill ranking of researchers via hypergraph",
    "publisher": "Peerj computer science",
    "version": "5",
    "year": 2019,
    "doi": "10.7717/peerj-cs.182/supp-1",
    "page": "e182",
    "filename": "Skill ranking of researchers via hypergraph.pdf",
    "download": true
  },
  {
    "id": 64,
    "author": "Xiangjie Kong, Yajie Shi, Shuo Yu, Jiaying Liu, and Feng Xia",
    "title": "Academic social networks: Modeling, analysis, mining and applications",
    "publisher": "Journal of Network and Computer Applications(J NETW COMPUT APPL)",
    "version": "132",
    "year": 2019,
    "doi": "10.1016/j.jnca.2019.01.029",
    "page": "86-103",
    "filename": "Academic social networks Modeling, analysis, mining and applications.pdf",
    "download": true
  },
  {
    "id": 65,
    "author": "Guoqiang Liang, Haiyan Hou, Peili Ren, Yi Bu, Xiangjie Kong, and Zhigang Hu",
    "title": "Understanding Nobel Prize-winning articles: a bibliometric analysis",
    "publisher": "CURRENT SCIENCE",
    "version": "116.3",
    "year": 2019,
    "doi": "10.18520/cs/v116/i3/379-385",
    "page": "379",
    "filename": "Understanding Nobel Prize-winning articles a bibliometric analysis.pdf",
    "download": true
  },
  {
    "id": 66,
    "author": "Liwei Cai, Jiahao Tian, Jiaying Liu, Xiaomei Bai, Ivan Lee, Xiangjie Kong, and Feng Xia",
    "title": "Scholarly impact assessment: a survey of citation weighting solutions",
    "publisher": "Scientometrics",
    "version": "118.2",
    "year": 2019,
    "doi": "10.1007/s11192-018-2973-6",
    "page": "453-478",
    "filename": "Scholarly impact assessment a survey of citation weighting solutions.pdf",
    "download": true
  },
  {
    "id": 67,
    "author": "Guojiang Shen, Difeng Zhu, Duanyuang Liu, Jingjing Chen, Yijiang Zhang",
    "title": "FCG-ASpredictor: An Approach for the Prediction of Average Speed of Road Segments with Floating Car GPS Data",
    "publisher": "Sensors",
    "version": "19.22",
    "year": 2019,
    "doi": "10.3390/s19224967",
    "page": "4967",
    "filename": "FCG-ASpredictor An Approach fornthe Prediction of.pdf",
    "download": true
  },
  {
    "id": 68,
    "author": "Duanyang Liu, Longfeng Tang, Guojiang Shen, Xiao Han",
    "title": "Traffic speed prediction: an attention-based method",
    "publisher": "Sensors",
    "version": "19.18",
    "year": 2019,
    "doi": "10.3390/s19183836",
    "page": "3836",
    "filename": "Traffic Speed Prediction An Attention-Based Method.pdf",
    "download": true
  },
  {
    "id": 69,
    "author": "Jianhui Lai",
    "title": "Traffic signal control based on double deep Q-learning network with dueling architecture",
    "publisher": "Computer Science",
    "version": "46.11A",
    "year": 2019,
    "doi": null,
    "page": "117-121",
    "filename": "Traffic Signal Control Based on Double Deep Q-learning Network with Dueling Architecture.pdf",
    "download": true
  },
  {
    "id": 70,
    "author": "Jianwei Zhen, Zhuorong Li, Wanliang Wang, Wanjun Chen",
    "title": "联合 Laplacian 正则项和特征自适应的数据聚类算法",
    "publisher": "软件学报",
    "version": "30.12",
    "year": 2019,
    "doi": null,
    "page": "3846-3861",
    "filename": "联合Laplacian正则项和特征自适应的数据聚类算法_郑建炜.pdf",
    "download": true
  },
  {
    "id": 71,
    "author": "Zhi Liu, Jiangchuan Li",
    "title": "基于深度卷积神经网络的三维模型检索",
    "publisher": "计算机科学",
    "version": "46.1",
    "year": 2019,
    "doi": null,
    "page": "278-284",
    "filename": "基于深度卷积神经网络的三维模型检索_刘志.pdf",
    "download": true
  },
  {
    "id": 72,
    "author": "Guojiang Shen, Linfeng Zhu, Jihan Lou, Si Shen, Zhi Liu, and Longfeng Tang",
    "title": "Infrared Multi-Pedestrian Tracking in VerticalView via Siamese ConvolutionNetwork",
    "publisher": "IEEE Access",
    "version": "7",
    "year": 2019,
    "doi": "10.1109/ACCESS.2019.2892469",
    "page": "42718-42725",
    "filename": "Infrared Multi-Pedestrian Tracking in Vertical View via Siamese Convolution Network Q-learning Network with Dueling Architecture.pdf",
    "download": true
  },
  {
    "id": 73,
    "author": "Jianwei Zheng, Kechen Lou, Xi Yang, Cong Bai, Jinhui Tang",
    "title": "Weighted mixed-norm regularized regression for robust face identification",
    "publisher": "IEEE transactions on neural networks and learning systems(IEEE Trans. Network Sci. Eng)",
    "version": "30.12",
    "year": 2019,
    "doi": "10.1109/TNNLS.2019.2899073",
    "page": "3788-3802",
    "filename": "Weighted mixed-norm regularized regression for robust face identification.pdf",
    "download": true
  },
  {
    "id": 80,
    "author": "Jianwei Zheng, Mengjie Qin, Xiaolong Zhou, Jiafa Mao, Hongchuan Yu",
    "title": "Efficient Implementation of Truncated Reweighting Low-Rank Matrix Approximation",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE Trans Industr Inform)",
    "version": "16.1",
    "year": 2019,
    "doi": "10.1109/TII.2019.2916986",
    "page": "488-500",
    "filename": "Efficient implementation of truncated reweighting low-rank matrix approximation.pdf",
    "download": true
  }
]

export const paper2020: IPaper[] = [
  {
    "id": 92,
    "author": "Noor Ullah, Xiangjie Kong*, Limei Lin, Mubarak Alrashoud, Amr Tolba, and Feng Xia",
    "title": "Real-time dissemination of emergency warning messages in 5G enabled selfish vehicular social networks.",
    "publisher": "Computer Networks",
    "version": null,
    "year": 2020,
    "doi": "10.1016/j.comnet.2020.107482",
    "page": null,
    "filename": "j.comnet.2020.107482.pdf",
    "download": true
  },
  {
    "id": 93,
    "author": "Xiangjie Kong, Feng Xia, Jianxin Li, Mingliang Hou, Menglin Li, Yong Xiang",
    "title": "A Shared Bus Profiling Scheme for Smart Cities Based on Heterogeneous Mobile Crowdsourced Data",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE Trans Industr Inform)",
    "version": null,
    "year": 2020,
    "doi": "10.1109/TII.2019.2947063",
    "page": null,
    "filename": "A_Shared_Bus_Profiling_Scheme_for_Smart_Cities_Based_on_Heterogeneous_Mobile_Crowdsourced_Data.pdf",
    "download": true
  },
  {
    "id": 59,
    "author": "Xiangjie Kong, Feng Xia, Zhenhuan Fu, Xiaoran Yan, Amr Tolba, Zafer Almakhadmeh",
    "title": "TBI2Flow: Travel Behavioral Inertia Based Long-Term Taxi Passenger Flow Prediction",
    "publisher": "World Wide Web(WWW)",
    "version": "23.2",
    "year": 2020,
    "doi": "10.1007/s11280-019-00700-1",
    "page": "1381-1405",
    "filename": "TBI2Flow Travel behavioral inertia based long-term taxi passenger flow prediction.pdf",
    "download": true
  },
  {
    "id": 74,
    "author": "Guojiang Shen, Xiangjie Kong, Xiangyu Zhu, Wei Xu, Longfeng Tang",
    "title": "Research on Phase Combination and Signal Timing Based on Improved K-Medoids Algorithm for Intersection Signal Control",
    "publisher": "Wireless Communications and Mobile Computing(Wirel Commun Mob Comput)",
    "version": null,
    "year": 2020,
    "doi": "10.1155/2020/3240675",
    "page": null,
    "filename": "Research on Phase Combination and Signal Timing Based on Improved K-Medoids Algorithm for Intersection Signal Control.pdf",
    "download": true
  },
  {
    "id": 75,
    "author": "Guojiang Shen, Xinye Fan, Zhongyuan Ruan",
    "title": "Totally asymmetric simple exclusion process on multiplex networks",
    "publisher": "Chaos: An Interdisciplinary Journal of Nonlinear Science(Chaos)",
    "version": "30.2",
    "year": 2020,
    "doi": "10.1063/1.5135618",
    "page": "023103",
    "filename": "Totally asymmetric simple exclusion process on multiplex networks.pdf",
    "download": true
  },
  {
    "id": 76,
    "author": "Wei Wang, Feng Xia, Hansong Nie, Zhikui Chen, Zhiguo Gong, Xiangjie Kong, Wei Wei",
    "title": "Vehicle Trajectory Clustering Based on Dynamic Representation Learning of Internet of Vehicles",
    "publisher": "IEEE Transactions on Intelligent Transportation Systems(IEEE Trans. Intell. Transp. Syst)",
    "version": null,
    "year": 2020,
    "doi": "10.1109/TITS.2020.2995856",
    "page": "1-10",
    "filename": "Vehicle Trajectory Clustering Based on Dynamic Representation Learning of Internet of Vehicles.pdf",
    "download": true
  },
  {
    "id": 77,
    "author": "Xiangjie Kong, Haoran Gao, Osama Alfarraj, Qichao Ni, Chaofan Zheng, Guojiang Shen",
    "title": "HUAD: Hierarchical Urban Anomaly Detection Based on Spatio-Temporal Data",
    "publisher": "IEEE Access",
    "version": "8",
    "year": 2020,
    "doi": "10.1109/ACCESS.2020.2971341",
    "page": "26573-26582",
    "filename": "HUADHierarchical Urban Anomaly Detection Based on Spatio-Temporal Data.pdf",
    "download": true
  },
  {
    "id": 78,
    "author": "Noor Ullah, Xiangjie Kong, Zhaolong Ning, Amr Tolba, Mubarak Alrashoud, Feng Xia",
    "title": "Emergency Message Dissemination in Vehicular Networks: A Review",
    "publisher": "Vehicular Communications(VEH COMMUN)",
    "version": "8",
    "year": 2020,
    "doi": "10.1109/ACCESS.2020.2975110",
    "page": "38606-38621",
    "filename": "Emergency warning messages dissemination in vehicular social networksA trust based scheme.pdf",
    "download": true
  },
  {
    "id": 79,
    "author": "Xiangjie Kong, Jun Zhang, Da Zhang, Yi Bu, Ying Ding, Feng Xia",
    "title": "The Gene of Scientific Success",
    "publisher": "ACM Transactions on Knowledge Discovery from Data (TKDD)",
    "version": "14.4",
    "year": 2020,
    "doi": "10.1145/3385530",
    "page": "1-19",
    "filename": "The Gene of Scientific Success.pdf",
    "download": true
  },
  {
    "id": 81,
    "author": "Xiaojie Wang, Yufan Feng, Zhaolong Ning, Xiping Hu, Xiangjie Kong, Bin Hu, Yi Guo",
    "title": "A Collective Filtering Based Content Transmission Scheme in Edge of Vehicles",
    "publisher": "Information Sciences",
    "version": "506",
    "year": 2020,
    "doi": "10.1016/j.ins.2019.07.083",
    "page": "161-173",
    "filename": "A collective filtering based content transmission scheme in edge of vehicles.pdf",
    "download": true
  },
  {
    "id": 82,
    "author": "Jianwei Zheng, Yuchao Feng, Cong Bai, Jinglin Zhang",
    "title": "Hyperspectral Image Classification Using Mixed Convolutions and Covariance Pooling",
    "publisher": "IEEE Transactions on Geoscience and Remote Sensing",
    "version": "59.1",
    "year": 2020,
    "doi": "10.1109/TGRS.2020.2995575",
    "page": "522-534",
    "filename": "Hyperspectral Image Classification Using Mixed.pdf",
    "download": true
  },
  {
    "id": 84,
    "author": "Xiao Han, Guojiang Shen, Xi Yang, Xiangjie Kong",
    "title": "Congestion Recognition for Hybrid Urban Road Systems via Digraph Convolutional Network",
    "publisher": "Transportation Research Part C(TR-C)",
    "version": "121",
    "year": 2020,
    "doi": "10.1016/j.trc.2020.102877",
    "page": "102877",
    "filename": "Congestion Recognition for Hybrid Urban Road Systems via Digraph Convolutional Network.pdf",
    "download": true
  },
  {
    "id": 85,
    "author": "Xiangjie Kong, Shiqin Tong, Haoran Gao, Guojiang Shen, Kailai Wang, Mario Collotta, Ilsun You, Sajal Das",
    "title": "Mobile Edge Cooperation Optimization for Wearable Internet of Things: A Network Representation-based Framework",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE T IND INFORM)",
    "version": null,
    "year": 2020,
    "doi": "10.1109/TII.2020.3016037",
    "page": null,
    "filename": "Mobile Edge Cooperation Optimization for Wearable Internet of Things A Network Representation-based Framework.pdf",
    "download": true
  }
]

export const paper2021: IPaper[] = [
  {
    "id": 91,
    "author": "Xiangjie Kong, Jiaxing Li, Luna Wang, Guojiang Shen, Yiming Sun, and Ivan Lee",
    "title": "Recurrent-DC: A deep representation clustering model for university profiling based on academic graph.",
    "publisher": "Future Generation Computer Systems(Future Gener Comput Syst)",
    "version": null,
    "year": 2021,
    "doi": "10.1016/j.future.2020.10.019",
    "page": null,
    "filename": "j.future.2020.10.019.pdf",
    "download": true
  },
  {
    "id": 90,
    "author": "Xiangjie Kong, Mengyi Mao, Wei Wang, Jiaying Liu, Bo Xu.",
    "title": "VOPRec: Vector Representation Learning of Papers with Text Information and Structural Identity for Recommendation",
    "publisher": "IEEE Transactions on Emerging Topics in Computing(IEEE Trans. Emerging Top)",
    "version": null,
    "year": 2021,
    "doi": "10.1109/TETC.2018.2830698",
    "page": null,
    "filename": "TETC.2018.2830698.pdf",
    "download": true
  },
  {
    "id": 89,
    "author": "Xiangjie Kong, Haoran Gao, Guojiang Shen, Gaohui Duan, Sajal K. Das",
    "title": "FedVCP: Federated Learning based Cooperative Positioning Scheme for Social Internet of Vehicles",
    "publisher": "IEEE Transactions on Computational Social Systems(IEEE Trans. Comput. Social Syst)",
    "version": null,
    "year": 2021,
    "doi": "10.1109/TCSS.2021.3062053",
    "page": null,
    "filename": "A Federated Learning based Cooperative Positioning Scheme for Social Internet of Vehicles.pdf",
    "download": true
  },
  {
    "id": 88,
    "author": "Xiangjie Kong, Kailai Wang, Mingliang Hou, Xinyu Hao, Guojiang Shen, Xin Chen, Feng Xia",
    "title": "A Federated Learning-based License Plate Recognition Scheme for 5G-enabled Internet of Vehicles",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE T IND INFORM)",
    "version": null,
    "year": 2021,
    "doi": "10.1109/TII.2021.3067324",
    "page": null,
    "filename": "A_Federated_Learning-Based_License_Plate_Recognition_Scheme_for_5G-Enabled_Internet_of_Vehicles.pdf",
    "download": true
  },
  {
    "id": 83,
    "author": "Guojiang Shen, Zhenzhen Zhao, Xiangjie Kong",
    "title": "GCN2CDD: A Commercial District Discovery Framework via Embedding Space Clustering on Graph Convolution Networks",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE T IND INFORM)",
    "version": null,
    "year": 2021,
    "doi": "10.1109/TII.2021.3051934",
    "page": null,
    "filename": "GCN2CDD_A_Commercial_District_Discovery_Framework_via_Embedding_Space_Clustering_on_Graph_Convolution_Networks.pdf",
    "download": true,
  },
  {
    "id": 86,
    "author": "Xiangjie Kong, Kailai Wang, Shupeng Wang, Xiaojie Wang, Xin Jiang, Yi Guo, Guojiang Shen, Xin Chen, and Qichao Ni",
    "title": "Real-time Mask Identification for COVID-19: An Edge Computing-based Deep Learning Framework",
    "publisher": "IEEE Internet of Things Journal(IEEE Internet Things J)",
    "version": null,
    "year": 2021,
    "doi": "10.1109/JIOT.2021.3051844",
    "page": null,
    "filename": "A Federated Learning based Cooperative Positioning Scheme for Social Internet of Vehicles.pdf",
    "download": true
  },
  {
    "id": 87,
    "author": "Xiangjie Kong, Bing Zhu, Guojiang Shen, Tewabe chekole Workneh, Zhanhao Ji, Yang Chen, and Zhi Liu",
    "title": "Spatial-Temporal-Cost Combination based Taxi Driving Fraud Detection for Collaborative Internet of Vehicles",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE T IND INFORM)",
    "version": null,
    "year": 2021,
    "doi": "10.1109/TII.2021.3111536",
    "page": null,
    "filename": "Spatial-Temporal-Cost Combination.pdf",
    "download": true
  },
]

export const paper2022: IPaper[] = [
  {
    "id": 99,
    "author": "Xiangjie Kong, Wenfeng Zhou, Guojiang Shen, Wenyi Zhang, Nali Liu, Yao Yang.",
    "title": "Dynamic graph convolutional recurrent imputation network for spatiotemporal traﬃc missing data.",
    "publisher": "Knowledge-Based Systems(Knowl. Based Syst)",
    "version": null,
    "year": 2022,
    "doi": "10.1007/s11280-022-01010-9",
    "page": null,
    "filename": "Dynamic graph.pdf",
    "download": true
  },
  {
    "id": 98,
    "author": "Xiangjie Kong, Zhiqiang Huang, Guojiang Shen, Hang Lin and Mingjie Lv",
    "title": "Urban Overtourism Detection Based on Graph Temporal Convolutional Networks.",
    "publisher": "IEEE Transactions on Computational Social Systems(IEEE Trans. Comput. Social Syst)",
    "version": null,
    "year": 2022,
    "doi": "10.1109/TCSS.2022.3226177",
    "page": null,
    "filename": "Urban_Overtourism_Detection_Based_on_Graph_Temporal_Convolutional_Networks.pdf",
    "download": true
  },
  {
    "id": 97,
    "author": "Guojiang Shen, NaLi Liu, Yinghui Liu, Wenfeng Zhou",
    "title": "Traffic Flow Imputation Based on Multi-Perspective Spatiotemporal Generative Adversarial Networks.",
    "publisher": "Proceedings of CECNet 2022(DPLP)",
    "version": null,
    "year": 2022,
    "doi": "10.3233/FAIA220519",
    "page": null,
    "filename": "Traffic Flow Imputation Based on Multi-Perspective Spatiotemporal Generative Adversarial Networks.pdf",
    "download": true
  },
  {
    "id": 96,
    "author": "Zhi Liu and Yang Chen and Feng Xia and Jixin Bian and Bing Zhu and Guojiang Shen and Xiangjie Kong",
    "title": "TAP: Traffic Accident Profiling via Multi-Task Spatio-Temporal Graph Representation Learning.",
    "publisher": "Association for Computing Machinery(ACM)",
    "version": null,
    "year": 2022,
    "doi": "10.1145/3564594",
    "page": null,
    "filename": "TAP.pdf",
    "download": true
  },
  {
    "id": 95,
    "author": "Guojiang Shen, Zhenzhen Zhao and Xiangjie Kong",
    "title": "GCN2CDD: A Commercial District Discovery Framework via Embedding Space Clustering on Graph Convolution Networks.",
    "publisher": "IEEE Transactions on Industrial Informatics(IEEE T IND INFORM)",
    "version": null,
    "year": 2022,
    "doi": "10.1109/TII.2021.3051934",
    "page": null,
    "filename": "GCN2CDD_A_Commercial_District_Discovery_Framework_via_Embedding_Space_Clustering_on_Graph_Convolution_Networks.pdf",
    "download": true
  },
  {
    "id": 94,
    "author": "Guojiang Shen, Difeng Zhu, Jingjing Chen, Xiangjie Kong",
    "title": "Motif discovery based traffic pattern mining in attributed road networks.",
    "publisher": "Knowledge-Based Systems(Knowl. Based Syst)",
    "version": null,
    "year": 2022,
    "doi": "10.1016/j.knosys.2022.109035",
    "page": null,
    "filename": "Motif Discovery based Traffic Pattern Mining in Attributed Road Networks.pdf",
    "download": true
  },
  {
    "id": 93,
    "author": "Xiangjie Kong, Nnali Li, Chenwei Zhang, Guojiang Shen, Zhaolong Ning and Tie Qiu",
    "title": "Multi-Feature Representation Based COVID-19 Risk Stage Evaluation With Transfer Learning.",
    "publisher": "IEEE Transactions on Network Science and Engineering(IEEE Trans. Netw. Sci. Eng)",
    "version": null,
    "year": 2022,
    "doi": "10.1109/TNSE.2022.3142316",
    "page": null,
    "filename": "Multi-Feature_Representation_Based_COVID-19_Risk_Stage_Evaluation_With_Transfer_Learning.pdf",
    "download": true
  },
  {
    "id": 92,
    "author": "Linan Zhu,Minhao Xu,Yifei Xu,Zhechao Zhu,Yanyan Zhao,Xiangjie Kong",
    "title": "A Multi-attribute Decision Making Approach based on Information Extraction for Real Estate Buyer Profiling.",
    "publisher": "World Wide Web(WWW)",
    "version": null,
    "year": 2022,
    "doi": "10.1007/s11280-022-01010-9",
    "page": null,
    "filename": "A Multi-attribute Decision Making Approach based on Information Extraction for Real Estate Buyer Profiling.pdf",
    "download": true
  },
]
export const paper2023: IPaper[] = [
  {
    "id": 100,
    "author": "Zhi Liu, Hanlin Zhou, Feng Xia, Guojiang Shen, Vidya Saikrishna, Xiaohua He, Jiaxin Du and Xiangjie Kong",
    "title": "Subgraph Federated Learning with Global Graph Reconstruction.",
    "publisher": "APWeb-WAIM International Joint Conference on Web and Big Data(APWeb-WAIM)",
    "version": null,
    "year": 2023,
    "doi": "78-981-97-2303-4_11",
    "page": null,
    "filename": "Subgraph Federated Learning with Global Graph Reconstruction.pdf",
    "download": true
  },
  {
    "id": 101,
    "author": "Linan Zhu, Yinwei Bao, Minhao Xu, Jianxin Li, Zhechao Zhu & Xiangjie Kong.",
    "title": "Aspect sentiment quadruple extraction based on the sentence-guided grid tagging scheme.",
    "publisher": "World Wide Web(WWW)",
    "version": null,
    "year": 2023,
    "doi": "10.1007/s11280-023-01185-9",
    "page": null,
    "filename": "Aspect sentiment quadruple extraction based on the sentence-guided grid tagging scheme.pdf",
    "download": true
  },
  {
    "id": 102,
    "author": "Linan Zhu, Zhechao Zhu, Chenwei Zhang, Yifei Xu, Xiangjie Kong.",
    "title": "Multimodal sentiment analysis based on fusion methods: A survey.",
    "publisher": "Information Fusion",
    "version": null,
    "year": 2023,
    "doi": "10.1016/j.inffus.2023.02.028",
    "page": null,
    "filename": "Multimodal sentiment analysis based on fusion methods.pdf",
    "download": true
  },
]
export const paper2024: IPaper[] = [
  {
    "id": 103,
    "author": "Lingyun Wang, Hanlin Zhou, Yinwei Bao, Xiaoran Yan, Guojiang Shen, and Xiangjie Kong ",
    "title": "Horizontal Federated Recommender System: A Survey.",
    "publisher": "Association for Computing Machinery(ACM).",
    "version": null,
    "year": 2024,
    "doi": "10.1145/3656165",
    "page": null,
    "filename": "Horizontal Federated Recommender System：A Survey.pdf",
    "download": true
  },
  {
    "id": 104,
    "author": "Xiangjie Kong and Chenhao Ni and Gaohui Duan  and  Guojiang Shen and Yao Yang  and Sajal K Das.",
    "title": "Energy Consumption Optimization of UAV-Assisted Traffic Monitoring Scheme With Tiny Reinforcement Learning.",
    "publisher": "IEEE Internet of Things Journal(IEEE Internet Things J)",
    "version": null,
    "year": 2024,
    "doi": "10.1109/JIOT.2024.3365293",
    "page": null,
    "filename": "Energy_Consumption_Optimization_of_UAV-Assisted_Traffic_Monitoring_Scheme_With_Tiny_Reinforcement_Learning.pdf",
    "download": true
  },
  {
    "id": 105,
    "author": "Zhi Liu and  Hanlin Zhou and Feng Xia and Guojiang Shen and Vidya Saikrishna  and Xiaohua He  and Jiaxin Du and Xiangjie Kong .",
    "title": "Subgraph Federated Learning with Global Graph Reconstruction.",
    "publisher": "Springer Nature Singapore(Nat. Singap)",
    "version": null,
    "year": 2024,
    "doi": "10.1007/978-981-97-2303-4-11",
    "page": "158--173.",
    "filename": "Subgraph Federated Learning with Global Reconstructure.pdf",
    "download": true
  },
  {
    "id": 106,
    "author": "Kong, Xiangjie and He, Yuwei and Shen, Guojiang and Du, Jiaxin and Liu, Zhi and Lee, Ivan.",
    "title": "Unbiased Anomalous Trajectory Detection with Hierarchical Sequence Modeling.",
    "publisher": "IEEE Transactions on Consumer Electronics",
    "version": null,
    "year": 2024,
    "doi": null,
    "page": null,
    "filename": "Unbiased_Anomalous_Trajectory_Detection_With_Hierarchical_Sequence_Modeling.pdf",
    "download": true
  },
  {
    "id": 107,
    "author": "Liu, Zhi and Deng, Junhui and Zhang, Deju and Shen, Guojiang and Kong, Xiangjie and others.",
    "title": "Dual Contrastive Learning for Next POI Recommendation with Long and Short-Term Trajectory Modeling.",
    "publisher": "CogSCI",
    "version": null,
    "year": 2024,
    "doi": null,
    "page": null,
    "filename": "Dual Contrastive Learning for Next POI Recommendation with Long and Short-Term Trajectory Modeling.pdf",
    "download": true
  },
  {
    "id": 108,
    "author": "Zhang, Yimei and Kong, Xiangjie and Zhou, Wenfeng and Liu, Jin and Fu, Yanjie and Shen, Guojiang.",
    "title": "A comprehensive survey on traffic missing data imputation.",
    "publisher": "IEEE Transactions on Intelligent Transportation Systems",
    "version": null,
    "year": 2024,
    "doi": null,
    "page": null,
    "filename": "A_Comprehensive_Survey_on_Traffic_Missing_Data_Imputation.pdf",
    "download": true
  },
  {
    "id": 109,
    "author": "Zhang, Wenyi and Kong, Xiangjie and Shen, Guojiang and Wu, Zhenpeng and Qu, Youyang.",
    "title": "Federated Adaptive Pseudo-Labeling Selection for Semi-Supervised Air Writing Recognition Systems.",
    "publisher": "IEEE Transactions on Consumer Electronics",
    "version": null,
    "year": 2024,
    "doi": null,
    "page": null,
    "filename": "Federated_Adaptive_Pseudo-Labeling_Selection_for_Semi-Supervised_Air_Writing_Recognition_Systems.pdf",
    "download": true
  },
  {
    "id": 110,
    "author": "Zhu, Linan and Chen, Xiangfan and Guo, Xiaolei and Zhang, Chenwei and Zhu, Zhechao and Zhou, Zehai and Kong, Xiangjie.",
    "title": "Pinpointing Diffusion Grid Noise to Enhance Aspect Sentiment Quad Prediction.",
    "publisher": "ACL-findings",
    "version": null,
    "year": 2024,
    "doi": null,
    "page": "3717--3726",
    "filename": "Pinpointing Diffusion Grid Noise to Enhance Aspect Sentiment Quad Prediction.pdf",
    "download": true
  }
]
export const paper2025: IPaper[] = [
  {
    "id": 111,
    "author": "Wang, Mengmeng and Huang, Zeyi and Kong, Xiangjie and Shen, Guojiang and Dai, Guang and Wang, Jingdong and Liu, Yong.",
    "title": "Action Detail Matters: Refining Video Recognition with Local Action Queries.",
    "publisher": "Computer Vision and Pattern Recognition(CVPR)",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": "19132--19142",
    "filename": "Wang_Action_Detail_Matters_Refining_Video_Recognition_with_Local_Action_Queries_CVPR_2025_paper.pdf",
    "download": true
  },
  {
    "id": 112,
    "author": "Mengmeng Wang, Haonan Wang, Yulong Li, Xiangjie Kong, Jiaxin Du, Feng Xia, and Guojiang Shen.",
    "title": "TrackAny3D: Transferring Pretrained 3D Models for Category-unified 3D Point Cloud Tracking.",
    "publisher": "International Conference on Computer Vision(ICCV)",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": null,
    "filename": "TrackAny3D_Transferring Pretrained 3D Models for Category-unified 3D Point Cloud Tracking.pdf",
    "download": true
  },
  {
    "id": 113,
    "author": "Zhang, Yuchao and Kong, Xiangjie and Ye, Kailun and Shen, Guojiang and Zheng, Shangfei",
    "title": "Tackling Sparse Facts for Temporal Knowledge Graph Completion.",
    "publisher": "World Wide Web(WWW).",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": "3561--3570.",
    "filename": "Tackling Sparse Facts for Temporal Knowledge Graph Completion.pdf",
    "download": true
  },
  {
    "id": 114,
    "author": "Weng, Wenchao and Wu, Mei and Jiang, Hanyu and Kong, Wanzeng and Kong, Xiangjie and Xia, Feng.",
    "title": "Pattern-Matching Dynamic Memory Network for Dual-Mode Traffic Prediction.",
    "publisher": "IEEE Transactions on Intelligent Transportation Systems(IEEE TITS)",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": null,
    "filename": "Pattern-Matching Dynamic Memory Network for Dual-Mode Traffic Prediction.pdf",
    "download": true
  },
  {
    "id": 115,
    "author": "Qihong Pan and Haofei Tan and Guojiang Shen and Xiangjie Kong and Mengmeng Wang and Chenyang Xu.",
    "title": "LLM-TPF: Multiscale Temporal Periodicity-Semantic Fusion LLMs for TimeSeries Forecasting.",
    "publisher": "International Joint Conference on Artificial Intelligence(IJCAI)",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": null,
    "filename": "LLM-TPF_Multiscale Temporal Periodicity-Semantic Fusion LLMs for TimeSeries Forecasting.pdf",
    "download": true
  },
  {
    "id": 116,
    "author": "Wenchao Weng and Hanyu Jiang and Mei Wu and Xiao Han and Haidong Gao and Guojiang Shen and Xiangjie Kong.",
    "title": "Let's group: A Plug-and-Play SubGraph Learning method for Memory-Efficient Spatio-Temporal Graph Modeling.",
    "publisher": "International Joint Conference on Artificial Intelligence(IJCAI)",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": null,
    "filename": "Let's group_A Plug-and-Play SubGraph Learning method for Memory-Efficient Spatio-Temporal Graph Modeling.pdf",
    "download": true
  },
  {
    "id": 117,
    "author": "Shen, Guojiang and He, Yuwei and Kong, Xiangjie and Ji, Zhanhao and Wang, Lei and Zhou, Junjie and Hu, Linglong.",
    "title": "Anomalous Trajectory Detection in Vehicular Social Networks with Unsupervised Dynamic Network Representation Learning.",
    "publisher": "IEEE Transactions on Vehicular Technology",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": null,
    "filename": "Anomalous_Trajectory_Detection_in_Vehicular_Social_Networks_with_Unsupervised_Dynamic_Network_Representation_Learning.pdf",
    "download": true
  },
  {
    "id": 118,
    "author": "Liu, Yinghui and Shen, Guojiang and Fu, Yanjie and Feng, Zehui and Zhao, Zhenzhen and Kong, Xiangjie.",
    "title": "Spatial homogeneity-aware transfer learning for urban flow prediction.",
    "publisher": "Springer Knowledge and Information Systems",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": "1--23",
    "filename": "Spatial homogeneity-aware transfer learning for urban flow prediction.pdf",
    "download": true
  },
  {
    "id": 119,
    "author": "Zhang, Yimei and Shen, Guojiang and Zhang, Wenyi and Ning, Kaili and Jiang, Renhe and Kong, Xiangjie.",
    "title": "Uncertainty-aware traffic accident risk prediction via multi-view hypergraph contrastive learning.",
    "publisher": "Elsevier Information Fusion",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": "103331",
    "filename": "Uncertainty-Aware Trafic Accident Risk Prediction via Multi-View Hypergraph Contrastive Learning.pdf",
    "download": true
  },
  {
    "id": 120,
    "author": "Kong, Xiangjie and Shu, Can and Wang, Lingyun and Zhou, Hanlin and Zhu, Linan and Li, Jianxin.",
    "title": "Broad information diffusion modelling for sharing link click prediction using knowledge graphs.",
    "publisher": "Elsevier EXPERT SYSTEMS WITH APPLICATIONS",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": "127276",
    "filename": "Broad Information Diffusion Modeling for Sharing Link Click Prediction Using Knowledge Graphs.pdf",
    "download": true
  },
  {
    "id": 121,
    "author": "Dai, Zhehao and Shen, Guojiang and Yuan, Haopeng and Zheng, Shangfei and Hu, Yuyue and Du, Jiaxin and Kong, Xiangjie and Xia, Feng.",
    "title": "Towards Heterogeneous Federated Graph Learning via Structural Entropy and Prototype Aggregation.",
    "publisher": "Elsevier Information Sciences",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": "122338",
    "filename": "Towards Heterogeneous Federated Graph Learning via Structural Entropy and Prototype Aggregation.pdf",
    "download": true
  },
  {
    "id": 122,
    "author": "Yi, Qiuhua and Kong, Xiangjie and Zhu, Linan and Zhang, Chenwei and Shen, Guojiang.",
    "title": "DiffuSyn: A Diffusion-Driven Framework with Syntactic Dependency for Aspect Sentiment Triplet Extraction.",
    "publisher": "IEEE Transactions on Audio Speech and Language Processing",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": null,
    "filename": "DiffuSyn_A_Diffusion-Driven_Framework_With_Syntactic_Dependency_for_Aspect_Sentiment_Triplet_Extraction.pdf",
    "download": true
  },
  {
    "id": 123,
    "author": "Zhu, Linan and Zhao, Hongyan and Zhu, Zhechao and Zhang, Chenwei and Kong, Xiangjie.",
    "title": "Multimodal sentiment analysis with unimodal label generation and modality decomposition.",
    "publisher": "Elsevier Information Fusion",
    "version": null,
    "year": 2025,
    "doi": null,
    "page": "102787",
    "filename": "Multimodal sentiment analysis with unimodal label generation and modality decomposition.pdf",
    "download": true
  }
]
export const paper = [
  ...paper2016, ...paper2017, ...paper2018, ...paper2019, ...paper2020, ...paper2021, ...paper2022, ...paper2023, ...paper2024, ...paper2025
]
